var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',{attrs:{"fluid":""}},[(_vm.IsAthleteLoading)?_c('v-skeleton-loader',{attrs:{"type":"card"}}):_c('AthleteScheduleCard',{attrs:{"showPast":"","showEdit":"","athleteProfile":_vm.TheAthleteProfile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }